import { connect, ConnectedProps } from 'react-redux'
import CommentWrapper from 'components/comments/CommentWrapper'
import { isRoles } from 'redux/actions'
import { RootState } from 'redux/store';

const mapStateToProps = (state: RootState) => ({
  userIs: (props: string) => isRoles(state, props)
})

const connector = connect(mapStateToProps, null);

export type CommentWrapperContainerProps = ConnectedProps<typeof connector>

export default connector(CommentWrapper)
